import React from "react";
import { Skeleton } from "../ui/skeleton";

const AirtimeSkeleton = () => {
  return (
    <div className="mt-4">
      <div className="grid grid-cols-4 justify-between">
        {[1, 2, 3, 4].map((_, index) => (
          <Skeleton className="size-20 rounded-lg" key={index} />
        ))}
      </div>

      <Skeleton className="mt-4 h-7 w-full rounded-md" />

      <div>
        <Skeleton className="mt-4 h-5 w-20 rounded-sm" />
        <Skeleton className="mt-2 h-10 w-full rounded-sm" />
      </div>

      <div>
        <Skeleton className="mt-4 h-5 w-20 rounded-sm" />
        <Skeleton className="mt-2 h-10 w-full rounded-sm" />
      </div>

      <div>
        <Skeleton className="mt-4 h-5 w-20 rounded-sm" />
        <Skeleton className="mt-2 h-10 w-full rounded-sm" />
      </div>

      <Skeleton className="mt-4 h-10 w-full rounded-lg" />
    </div>
  );
};

export default AirtimeSkeleton;
